<template>
    <div class="container-center">
      <span class="geolocation__title"> Localización actual no disponible </span>
      <img src="@/assets/img/geolocation.png" class="geolocation__image" />
      <span class="geolocation__description"> Ve a los ajustes de tu móvil y acepta los permisos de localización dentro de los ajustes de tu navegador</span>
      <div class="geolocation-card">
        <span class="geolocation-card__title">Desde iOS</span>
        <span class="geolocation-card__description">Ajustes > Chrome/Safari > Localización > Mientras use la app.</span>
      </div>
      <div class="geolocation-card">
        <span class="geolocation-card__title">Desde Android</span>
        <span class="geolocation-card__description">Ajustes > Chrome > Localización > Mientras use la app.</span>
      </div>
      <button class="button-block button__primary" @click="backHome()">Reintentar</button>
    </div>
  </template>
  
<script setup>
  const backHome = ()=> {
    window.location.reload()
  }
</script>
  
<style lang="scss" scoped>
  @import '@/scss/mixings';

  %title-placeholder {
    color: var(--text-color);
    text-align: center;
    font-size: 1rem;
    font-weight: var(--fw-medium);
    line-height: 20px; 
  }
  %description-placeholder {
    color: var(--text-color);
    text-align: center;
    font-size: 1rem;
    font-weight: var(--fw-normal);
    line-height: 22px; 
  }

  .geolocation__title {
    @extend %title-placeholder; 
  }
  .geolocation__description {
    @extend %description-placeholder; 
  }

  .geolocation__image {
    align-self: center;
    width: 135px;
    height: 125px;
  }

  .geolocation-card{
    @include d-flex(column,space-around,center);
    width: 300px;
    height: 100px;
    padding: 10px;
    background: var(--neutral-10);
    border-radius: 5px;
    &__title{
      @extend %title-placeholder; 
    }
    &__description{
      @extend %description-placeholder; 
    }
  }
</style>